---
id: orders-service-go
title: Orders service
owner: Backend Team
status: Active
lastReviewed: 2026-02-02
visibility: internal
tags:
  - orders
  - reviews
  - microservice
  - firestore
---

## Product Overview

### Who it serves

This microservice supports order and review queue workflows for Rezi users and internal tools that need access to order records.

### Primary workflow

Authenticated clients query free-review eligibility, review queue status, and manage order records through listing, update, deletion, and transfer operations.

### Business rules

All routes require Firebase authentication, free-review eligibility checks look back 30 days, and order updates validate the network to prevent unauthorized changes.

### Outcomes

Order data is returned for dashboards and operations, and updates to order status or reviewer assignment are persisted for downstream review processing.

### Out of scope

Payment processing, resume parsing, and user profile management are handled by other services.

### API documentation

[Internal API Documentation](https://wiki.rezi.ai/apis/orders-service-go-api-docs)

## Technical Overview

### Architecture flow

`apps/micro-services/orders-service-go/cmd/order/main.go` loads environment configuration, initializes Firebase, and registers routes from `apps/micro-services/orders-service-go/pkg/api/routes/routes.go` into the shared API server.

### Entry points

- The HTTP service entry point is `apps/micro-services/orders-service-go/cmd/order/main.go`.
- The OpenAPI generator entry point is `apps/micro-services/orders-service-go/cmd/spec/main.go`, which builds `spec.json` from the route definitions.

### Key modules

Order business logic lives in `apps/micro-services/orders-service-go/pkg/services/ordersService.go`, transfer logic lives in `apps/micro-services/orders-service-go/pkg/services/transfers/orders.go`, and Firestore repository utilities live under `apps/micro-services/orders-service-go/pkg/repo/nosql/firestore`.

### Data sources and sinks

Order data is stored and queried in Firestore collections via the repository layer in `apps/micro-services/orders-service-go/pkg/repo/nosql/firestore`, with Firebase initialization in `apps/micro-services/orders-service-go/pkg/adaptor/firebase`.

### Integrations and side effects

The service integrates with Firebase auth, reads and updates order documents in Firestore, and provides transfer operations that reassign order ownership between users.

### Constraints and risks

Review queue calculations depend on Firestore query results and time-based logic, and order updates will fail if network validation does not match the stored order.

## Changelog

- 2026-02-03: Can have custom token
- 2026-02-02: Initial documentation.
